/* tslint:disable */
/* eslint-disable */
/**
 * Telematics API
 * Telematics services API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ClientApplication,
    ClientApplicationFromJSON,
    ClientApplicationFromJSONTyped,
    ClientApplicationToJSON,
    MainDataVersion,
    MainDataVersionFromJSON,
    MainDataVersionFromJSONTyped,
    MainDataVersionToJSON,
} from './';

/**
 * 
 * @export
 * @interface MainDataResClientApplicationArray
 */
export interface MainDataResClientApplicationArray {
    /**
     * 
     * @type {MainDataVersion}
     * @memberof MainDataResClientApplicationArray
     */
    version: MainDataVersion;
    /**
     * 
     * @type {Array<ClientApplication>}
     * @memberof MainDataResClientApplicationArray
     */
    data?: Array<ClientApplication> | null;
    /**
     * 
     * @type {string}
     * @memberof MainDataResClientApplicationArray
     */
    error?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MainDataResClientApplicationArray
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MainDataResClientApplicationArray
     */
    total?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MainDataResClientApplicationArray
     */
    limit?: number | null;
}

export function MainDataResClientApplicationArrayFromJSON(json: any): MainDataResClientApplicationArray {
    return MainDataResClientApplicationArrayFromJSONTyped(json, false);
}

export function MainDataResClientApplicationArrayFromJSONTyped(json: any, ignoreDiscriminator: boolean): MainDataResClientApplicationArray {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'version': MainDataVersionFromJSON(json['version']),
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(ClientApplicationFromJSON)),
        'error': !exists(json, 'error') ? undefined : json['error'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'total': !exists(json, 'total') ? undefined : json['total'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function MainDataResClientApplicationArrayToJSON(value?: MainDataResClientApplicationArray | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'version': MainDataVersionToJSON(value.version),
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(ClientApplicationToJSON)),
        'error': value.error,
        'offset': value.offset,
        'total': value.total,
        'limit': value.limit,
    };
}


